import HixChart from "./hix-chart";

export default HixChart;